import { render, staticRenderFns } from "./PromoOdr.vue?vue&type=template&id=7c7be802&scoped=true"
import script from "./PromoOdr.vue?vue&type=script&lang=js"
export * from "./PromoOdr.vue?vue&type=script&lang=js"
import style0 from "./PromoOdr.vue?vue&type=style&index=0&id=7c7be802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7be802",
  null
  
)

export default component.exports